import { z } from "zod";

export const UpsertGatesSchema = z.object({
  gates: z.array(
    z.object({
      id: z.string(),
      name: z.string().min(1, "Le nom de la porte est requis").max(64, "Le nom de la porte ne peut pas dépasser 64 caractères"),
    })
  ),
  name: z.string().max(64, "Le nom de la porte ne peut pas dépasser 64 caractères").optional(),
});

export const defaultUpsertGatesValues = {
  gates: [],
  name: "",
};

export type UpsertGatesForm = z.infer<typeof UpsertGatesSchema>;
